/**
 * @ngdoc controller
 * @name navigation.sidenav.controllers:SideNavComponentController
 * @element
 * @description
 *
 */

class SideNavComponentController {
    constructor($rootScope, NavService) {
        this.navigator = NavService;
        this.scope = $rootScope;
        this.state = $rootScope.$state;
        this.sidenav = [];
        this._updateSideNav();

        $rootScope.$on('al-nav-update-sidenav', () => {
            this._updateSideNav();
        })
    }

    _updateSideNav() {
        this.navigator.getCurrentSideNav().then(sidenav => {
            this.sidenav = sidenav;
            this.scope.$applyAsync();
        }, e => {
            console.error('error while updating breadcrumb', e);
        });
    }

    goToElem(elem) {
        this.navigator.goToElem(elem.key, {})
    }

    toggleSideNavStatus() {
        this.state.current.data.collapsedSidebarOnLoad = !this.state.current.data.collapsedSidebarOnLoad;
    }

    goBack() {
        this.navigator.goBack();
    }
}

angular
    .module('festzelt-os.components')
    .controller('SideNavComponentController', [
        '$rootScope',
        'NavService',
        SideNavComponentController
    ]);



// WEBPACK FOOTER //
// ./src/app/components/navigation/components/sidenav/controllers/component-controller.js